<div [id]="id" class="tree-node tree-node-content item"
    [ngClass]="{'group-node': columnDef.isGroup, 'active': columnDef === liveWidgetSettingsService.selectedComponent.field, 'marked-deleted': columnDef.remove}"
    (click)="updateSelectedComponent.emit({componentDef: columnDef, componentType: 'field', index, event: $event})"
    title="{{columnDef._isDeleteDisabled ? locale.HELP_MESSAGE_DISABLE_PRIMARY_DELETE : ''}}">
    <!--Toggle icon-->
    <i title="{{locale.LABEL_EXPAND + '/' + locale.LABEL_COLLAPSE}}" class="toggle wms"
        [ngClass]="{'wms-arrow-right': collapsed,'wms-arrow-down': !collapsed}"
        *ngIf="columnDef.columns && columnDef.columns.length > 0" (click)="toggleGroup(this, $event)"></i>
    <!--PC/ Mobile display checkbox-->
    <span class="checkbox-container" *ngIf="!columnDef.isGroup">
        <input class="app-checkbox" [hidden]="columnDef._isDeleteDisabled" type="checkbox" [attr.name]="'pcDisplay-'+(columnDef.field || columnDef.key)"
            [(ngModel)]="columnDef.pcDisplay" (ngModelChange)="updateSelectAll('field', 'pcDisplay', columnDef)" />
    </span>
    <span class="checkbox-container" *ngIf="!columnDef.isGroup">
        <input class="app-checkbox" [hidden]="columnDef._isDeleteDisabled" type="checkbox" [attr.name]="'mobileDisplay-'+(columnDef.field || columnDef.key)"
            [(ngModel)]="columnDef.mobileDisplay"
            (ngModelChange)="updateSelectAll('field', 'mobileDisplay', columnDef)" />
    </span>
    <span class="checkbox-container" *ngIf="!columnDef.isGroup">
        <input class="app-checkbox" [hidden]="columnDef._isDeleteDisabled" type="checkbox" [attr.name]="'tabletDisplay-'+(columnDef.field || columnDef.key)"
            [(ngModel)]="columnDef.tabletDisplay"
            (ngModelChange)="updateSelectAll('field', 'tabletDisplay', columnDef)" />
    </span>
    <!--Title-->
    <span class="list-title title"
        title="{{columnDef.displayname || columnDef.displayName}}">{{liveWidgetSettingsService.getDisplayName(columnDef)}}</span>
    <!--Reorder icon-->
    <i title="{{locale.LABEL_REORDER}}" class="wms wms-reorder hover-fix reorder-icon"></i>
    <!--Related icon-->
    <i *ngIf="columnDef.isRelated" class="wm-icon wm-icon12 wms wms-swap-horiz related-icon"></i>
    <!--Delete/ undo icon-->
    <i class="wm-icon wms hover-fix"
        title="{{columnDef.remove ? locale.LABEL_RESTORE_FIELD : locale.LABEL_DELETE_FIELD}}"
        [ngClass]="{'wms-undo undo': columnDef.remove, ' wms-delete delete-icon': !columnDef.remove}"
        (click)="columnDef.isGroup ? deleteGroup(liveWidgetSettingsService.headerConfig, columnDef) : deleteField(columnDef)"
        [hidden]="columnDef._isDeleteDisabled"></i>
</div>
<!--Inner columns-->
<div class="angular-ui-tree">
    <ol class="angular-ui-tree-nodes" [ngClass]="{'hidden': collapsed}">
        <li *ngFor="let innerColumnDef of columnDef.columns; index as i" class="list-item angular-ui-tree-node"
            [ngClass]="{'active': innerColumnDef.field === liveWidgetSettingsService.selectedComponent?.field}">
            <wms-live-widgets-fields-list id="{{id}}-{{i}}" [index]="i" [columnDef]="innerColumnDef"
                (updateSelectedComponent)="updateSelectedComponent.emit($event)"></wms-live-widgets-fields-list>
        </li>
    </ol>
</div>
